module.exports = __webpack_public_path__ + "static/media/3coachHeader.300ff3cd.svg";